import { useCreateWhatsAppTemplateMessage } from 'src/modules/shared/messaging/hooks/api/whatsapp-template-message-mutation';
import type { WhatsAppTemplateSend } from 'src/modules/shared/messaging/types/whatsapp-template-send.types';
import { buildWhatsAppTemplateSendParams } from 'src/modules/shared/messaging/utils/whatsapp-template-send.util';
import { conversationTemplateMutationCallbacks } from '../../../utils/cache/template-message-mutation.util';
import { getTemplateAttribution } from '../../../utils/whatsapp/template-attribution.util';
import type { ConversationWhatsAppTemplateContext } from '../../../types/whatsapp/template-send.types';

/**
 * Owns the complete optimistic lifecycle for template sends in a CRM conversation.
 * @param conversation - Identity copied into each submission before asynchronous work.
 * @returns A UI-facing action that settles after cache reconciliation and pending state.
 */
export const useSendConversationWhatsAppTemplate = (
  conversation: ConversationWhatsAppTemplateContext
): WhatsAppTemplateSend => {
  const mutation = useCreateWhatsAppTemplateMessage(
    conversationTemplateMutationCallbacks
  );
  return {
    isPending: mutation.loading,
    sendTemplate: async (draft) => {
      const params = buildWhatsAppTemplateSendParams(draft);
      await mutation.createWhatsAppTemplateMessageAsync({
        ...params,
        optimisticData: {
          ...params.optimisticData,
          ...getTemplateAttribution(draft, conversation),
        },
      });
    },
  };
};
